module.exports = __webpack_public_path__ + "img/image01_sp.ad5b1330.jpg";